import { TFeaturedItemType } from "../../Views/Homepage/Featured/@types";
import { analytics } from "MVVM/Analytics";
export const analyticsClickEvent = (type: TFeaturedItemType, name?: string) => {
  switch (type) {
    case "promotion":
      analytics.track("Button - Click", {
        location: "homepage_carousel",
        locationIdentifier: "promotion_button",
        source: "website",
      });
      break;
    case "motw":
      analytics.track("Button - Click", {
        location: "homepage_carousel",
        locationIdentifier: "motw_watch_clip",
        source: "website",
      });
      break;
    case "cotd":
      analytics.track("Button - Click", {
        location: "homepage_carousel",
        locationIdentifier: "cotd_watch_clip",
        source: "website",
      });
      break;
    case "top5":
      analytics.track("Button - Click", {
        location: "homepage_carousel",
        locationIdentifier: "top5_watch_clip",
        source: "website",
      });
      break;
    default:
      break;
  }
};

export const analyticsSlideEvent = (type: TFeaturedItemType, name?: string) => {
  switch (type) {
    case "promotion":
      analytics.track("Promotion - Impression", {
        type: "carouselSlide",
        promotionName: name || "",
      });
      break;
    case "motw":
      analytics.track("Montage of the Week - Impression", {
        type: "carouselSlide",
        promotionName: name || "",
      });
      break;
    case "cotd":
      analytics.track("Clip of the Day - Impression", {
        type: "carouselSlide",
        promotionName: name || "",
      });
      break;
    case "top5":
      analytics.track("Top 5 - Impression", {
        type: "carouselSlide",
        promotionName: name || "",
      });
      break;
    default:
      break;
  }
};
